/**
 * Video Background
 */
function setup_video(e){
    var config = [];
    if($('#bgvid').length) config.push({el:"#bgvid", srcs:"#bgvid-srcs"});
    var attr_key = e==="desktop" ? "desktop-poster" : "mobile-poster"


    for(var i=0; i<config.length; i++){
        var vid_id = config[i].el;
        var video = $(vid_id);
        if(video.length){  
            var poster = video.attr(attr_key);
            video.attr("poster",poster);
			
            if($(config[i].srcs).length>0) {
				
                for(var o=JSON.parse($(config[i].srcs).text())[e],d=0;d<o.length;d++){
                    video.append('<source content="default-src *; style-src \'self\' http://* \'unsafe-inline\'; script-src \'self\' http://* \'unsafe-inline\' \'unsafe-eval\'" src="'+o[d].src+'" type="'+o[d].type+'">');
                }
            }    
        }
    }    
}

(function($){

	$(document).ready( function() {

		console.log("document is ready")

		$('.video-wrap').fitVids();

		// initialize();
		
		// Focus Overlay		
		const fo = new FocusOverlay(document.body);
		$('#menu-nav-primary > li > a').on('focusin', function(e) {
			$(this).parent().addClass('focused');
		});
		$('.sub-menu > li:last-of-type > a').on('focusout', function(e) {
			console.log('the last item in a submenu has been unfocused');
			$(this).parents('#menu-nav-primary > li').removeClass('focused');
		});

		// ensure unique labels on search forms
		$('#main-search input').on('focus', function(e, f) {

			// if is #s2, swap #s1 and #s2
			var thisForm = $(e.target);			
			var thisFormLabel  =$('label[for="'+thisForm.attr('name')+'"]');

			var thatFormSelector = thisForm.attr('id') === 's' ? 'input#s2' : 'input#s';
			var thatForm = $(thatFormSelector);
			var thatFormLabel = $('label[for="'+thatForm.attr('name')+'"]');

			if ( thisForm === 's' ) {
				thisForm.attr('id', 		's2');
				thisForm.attr('name', 		's2');
				thisFormLabel.attr('for', 	's2');

				thatForm.attr('id', 		's');
				thatForm.attr('name', 		's');
				thatFormLabel.attr('for', 	's');
			} else {
				thisForm.attr('id', 		's');
				thisForm.attr('name', 		's');
				thisFormLabel.attr('for', 	's');

				thatForm.attr('id', 		's2');
				thatForm.attr('name', 		's2');
				thatFormLabel.attr('for', 	's2');
			}
		});
	
		$(window).on("load", function() {
			650 < $(window).width() ?
				setup_video("desktop") :
				setup_video("mobile");
		});
	
		// mobile menu nav handling
		$('.menu-toggle').on('click', function(){
			$(this).toggleClass('closer');
			$('body').toggleClass('menu-open');
			$('.nav-primary').toggleClass('active');
		});
	
		// const activeNavLink = $('#menu-nav-primary li.active')
		if( $('.current-menu-ancestor').length > 0 ) {
			
		}
		$('.current-menu-ancestor .caret').attr('rotation', 180);
	
		$('.caret').on('click', e => {
			const _this = $(e.currentTarget);		
			const rotatationVal =  180 + parseInt(_this.attr('rotation') ? _this.attr('rotation') : 0);
		
			// spin caret
			_this.css('transform', 'rotate(' + rotatationVal +'deg)');
			_this.attr('rotation', rotatationVal);
			
			// open submenu
			const submenu = _this.siblings('.sub-menu');
			submenu.slideToggle();		
		})
	
		// sticky footer
		// var minH = $(window).height() - ( $('footer').outerHeight() + $('.subscribe').outerHeight() + $('.sponsors').outerHeight() );
		// console.log('this is the min height: ', minH);
		// $('.wrap').css({minHeight:minH});
	
		// banner slider
		if( $('#frontpage .banner-slider').length > 0 ) {
			$('.banner-slider').slick({
				arrows: false,
				dots: true,
				autoplay: true,
				autoplaySpeed: 5000,
				adaptiveHeight: false,
				responsive: [
					{
						breakpoint: 1100,
						settings: {
							adaptiveHeight: true,
							autoplay: false
						}
					}
				]
			});
		}
	
		// sponsors slider
		if( $('.sponsors-slider').length > 0 ) {
			$('.sponsors-slider').slick({
				arrows: true,
				prevArrow: '<div class="slick-prev"><i class="far fa-angle-left"></i></div>',
				nextArrow: '<div class="slick-next"><i class="far fa-angle-right"></i></div>',
				dots: false,
				autoplay: true,
				autoplaySpeed: 3000,
				slidesToShow: 6,
				slidesToScroll: 1,
				infinite: true,
				responsive: [
					{
						breakpoint: 798,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 2
						}
					}
				]
			});
	
			$('.sponsors .slick-prev').on("click", function() {
				$('.sponsors-slider').slick('slickPrev');
			});
	
			$('.sponsors .slick-next').on("click", function() {
				$('.sponsors-slider').slick('slickNext');
			});
		}
	
		// events category dropdown
	$("#event-category-select").on("change", e => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
	
		const selectedCategory = $(e.target).children('option:selected')[0];
	
		console.log('SELECTED CATEGORY: ', selectedCategory);
	
		console.log('PARAMS: ');
		console.log(params);
	
		const currentHref = window.location.href;
		let newHref = currentHref+'&tribe_eventcategory%5B0%5D='+$(e.target).val();
	
		Object.entries(params).forEach( (k) => console.log(k) );
	
		console.log('NEW HREF: ', newHref);
		window.location.href = newHref;
	})
	
		
	
		// normalize grid cell height
		// const upcomingEventsGridHeight = $('.upcoming-events-grid .grid-cell')[0].height();
		// $('.upcoming-events-grid .grid-cell .visual-link').each( (_, el) => {
		// 	if(el.height() < upcomingEventsGridHeight) {
		// 		console.log('we need to normalize')
		// 	}
		// })
		
		//init Swipe
		// $( '.swipebox' ).swipebox({
		// 	hideBarsDelay:0,
		// });
	
		//expander handling
		$('.expander-title').on("click", function() {
			$(this).toggleClass('open');
			$(this).siblings('.expander-content').slideToggle();
		})
	});

})(jQuery);

// GOOGLE MAPS
var apiKey = 'AIzaSyAc3ttdZu4aLDQ3tDvb3DaoPGg-viEoFvw';
var lat = 34.3654343;
var lng = -89.531088; 
function initialize() {
	var location = {lat: lat, lng:lng}
	var map;
	var mapOptions = {
		zoom:15,
		center: location,
		scrollwheel: false,
		title: 'Directions to the Ford Center'
	};
	
	map = new google.maps.Map(document.getElementById("map"), mapOptions);       
	var marker = new google.maps.Marker({
		position: location,
		map: map,
	});                

}
(function($){
		
		$(document).ready(function(){
			if ($('#map').length){
				 // Asynchronously Load the map API 
			var script = document.createElement('script');
			script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key="+apiKey;
			document.body.appendChild(script);	
			}
		});
				
})(jQuery)